import {
  GET_FACILITY_HOLIDAY_LIST,
  GET_FACILITY_HOLIDAY_LIST_SUCCESS,
  GET_FACILITY_HOLIDAY_LIST_ERROR,
  GET_FACILITY_HOLIDAY_LIST_EMPTY,
} from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetFacilityHolidayList = (state = initialState, action) => {
  switch (action.type) {
    case GET_FACILITY_HOLIDAY_LIST:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_FACILITY_HOLIDAY_LIST_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_FACILITY_HOLIDAY_LIST_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_FACILITY_HOLIDAY_LIST_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetFacilityHolidayList;
